import type { VatRateCountVm, VatSourceVm } from '@krp/platform-ui'

/** Чистая сборка vm вкладки «Настройка»: общая часть (общий каталог и состояние запроса). Источники собирают свои vm сами. Без React, без store. */

export const LOCAL_NO_DATA =
  'У товара общего каталога поля «ставка НДС» нет: ставка хранится в источниках (в 1С — на товаре). Число товаров здесь — для сверки.'

export interface QueryLike {
  isLoading: boolean
  isError: boolean
  errorMessage: string | null
}

export function localSourceVm(args: { total: number | null; query: QueryLike }): VatSourceVm {
  const { total, query } = args
  const base = { id: 'local', title: 'Общий каталог (наш сервер)', badge: 'Наш сервер', rates: [] as VatRateCountVm[], withVat: null, withoutVat: null, editor: null }
  if (total === null) {
    return query.isError
      ? { ...base, total: null, status: 'error', message: query.errorMessage, note: null }
      : { ...base, total: null, status: 'loading', message: null, note: null }
  }
  return { ...base, total, status: 'no-data', message: LOCAL_NO_DATA, note: null }
}
